import React, { useState } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';

import contact from './img/contact.jpg';

const Contact = () => {
    // State to hold form input values
    const [formData, setFormData] = useState({
        Name: '',
        email: '',
        age: '',
        mobile: '',
        appointmentDate: '',
        address: '',
        description: ''
    });

    // Handle form input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    // Handle form submission to redirect to WhatsApp
    const handleSubmit = (e) => {
        e.preventDefault();

        const message = encodeURIComponent(
            `Hi, I am interested in booking an appointment. 
            Name: ${formData.Name}, 
            Email: ${formData.email}, 
            Age: ${formData.age}, 
            Mobile: ${formData.mobile}, 
            Appointment Date: ${formData.appointmentDate}, 
            Address: ${formData.address}, 
            Description: ${formData.description}`
        );

        const whatsappURL = `https://wa.me/919415026762?text=${message}`;

        // Redirect to WhatsApp
        window.location.href = whatsappURL;
    };

    return (
        <>
            <div className='contacts'>
                <div className='contacts2'>
                    <br />
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Col>
                                <Form.Control 
                                  type="text" 
                                  placeholder=" name" 
                                  name="Name" 
                                  value={formData.Name} 
                                  onChange={handleChange} 
                                />
                            </Col>
                            <Col>
                                <Form.Control 
                                  type="email" 
                                  placeholder="Email" 
                                  name="email" 
                                  value={formData.email} 
                                  onChange={handleChange} 
                                />
                            </Col>
                        </Row>

                        <br /><br />
                        <Row>
                            <Col>
                                <Form.Control 
                                  type="text" 
                                  placeholder="Age" 
                                  name="age" 
                                  value={formData.age} 
                                  onChange={handleChange} 
                                />
                            </Col>
                            <Col>
                                <Form.Control 
                                  type="text" 
                                  placeholder="Mobile" 
                                  name="mobile" 
                                  value={formData.mobile} 
                                  onChange={handleChange} 
                                />
                            </Col>
                        </Row>

                        <br /><br />
                        <Row>
                            <Col>
                                <Form.Control 
                                  type="text" 
                                  placeholder="Appointment date" 
                                  name="appointmentDate" 
                                  value={formData.appointmentDate} 
                                  onChange={handleChange} 
                                />
                            </Col>
                            <Col>
                                <Form.Control 
                                  type="text" 
                                  placeholder="Address" 
                                  name="address" 
                                  value={formData.address} 
                                  onChange={handleChange} 
                                />
                            </Col>
                        </Row>
                        <br /><br />
                        <Row>
                            <Col>
                                <Form.Control 
                                  as="textarea" 
                                  placeholder="Description" 
                                  name="description" 
                                  value={formData.description} 
                                  onChange={handleChange} 
                                />
                            </Col>
                        </Row>

                        <br /><br />

                        <button className='btn btn-success' type="submit">Submit</button>
                    </Form>
                </div>

                <div className='contacts2'>
                    <img src={contact} alt="Contact" />
                </div>

            </div>
        </>
    );
};

export default Contact;
